export default {
    namespaced: true,
    state: {
		endpoint: 'realty/type',
		item: {},
        items: [],
    },
}